import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { mockData } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-[#2C2C2A] text-white border-t border-[#2C2C2A]/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info with Full Logo */}
          <div className="space-y-4 lg:col-span-2">
            <a href="/" className="block">
              <img 
                src="https://customer-assets.emergentagent.com/job_disability-care-hub/artifacts/k17oy3qe_Smile-A-Pal.png" 
                alt="Smile a Pal - Disability Care" 
                className="h-32 w-auto"
              />
            </a>
            <p className="text-[#E4E1D8] max-w-md">
              Empowering lives with compassionate disability support services through the NDIS.
            </p>
            <div className="flex space-x-3 mt-6">
              <a href="#" className="w-10 h-10 bg-[#0F6E56] rounded-lg flex items-center justify-center hover:bg-[#5DCAA5] transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-[#0F6E56] rounded-lg flex items-center justify-center hover:bg-[#5DCAA5] transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-[#0F6E56] rounded-lg flex items-center justify-center hover:bg-[#5DCAA5] transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-[#0F6E56] rounded-lg flex items-center justify-center hover:bg-[#5DCAA5] transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-[#E4E1D8] hover:text-[#5DCAA5] transition-colors">
                  About Us
                </a>
              </li>
              <li>
                <a href="#services" className="text-[#E4E1D8] hover:text-[#5DCAA5] transition-colors">
                  Our Services
                </a>
              </li>
              <li>
                <a href="https://www.ndis.gov.au/understanding-ndis/about-ndis" target="_blank" rel="noopener noreferrer" className="text-[#E4E1D8] hover:text-[#5DCAA5] transition-colors">
                  NDIS Information
                </a>
              </li>
              <li>
                <a href="#resources" className="text-[#E4E1D8] hover:text-[#5DCAA5] transition-colors">
                  Resources
                </a>
              </li>
              <li>
                <a href="/blog" className="text-[#E4E1D8] hover:text-[#5DCAA5] transition-colors">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#5DCAA5] mt-0.5 flex-shrink-0" />
                <div>
                  <a href={`tel:${mockData.companyInfo.phone.replace(/[^0-9]/g, '')}`} className="text-[#E4E1D8] hover:text-[#5DCAA5] transition-colors">
                    {mockData.companyInfo.phone}
                  </a>
                  <p className="text-sm text-[#6B6B69]">24/7 Support</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#5DCAA5] mt-0.5 flex-shrink-0" />
                <a href={`mailto:${mockData.companyInfo.email}`} className="text-[#E4E1D8] hover:text-[#5DCAA5] transition-colors">
                  {mockData.companyInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#5DCAA5] mt-0.5 flex-shrink-0" />
                <span className="text-[#E4E1D8]">
                  {mockData.companyInfo.address}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#2C2C2A]/30 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#E4E1D8] text-sm">
              © {new Date().getFullYear()} {mockData.companyInfo.name}. All Rights Reserved.
            </p>
            <div className="flex gap-6">
              <a href="/privacy-policy" className="text-[#E4E1D8] hover:text-[#5DCAA5] transition-colors text-sm">
                Privacy Policy
              </a>
              <a href="/terms" className="text-[#E4E1D8] hover:text-[#5DCAA5] transition-colors text-sm">
                Terms of Service
              </a>
              <a href="/accessibility" className="text-[#E4E1D8] hover:text-[#5DCAA5] transition-colors text-sm">
                Accessibility
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;